import React from 'react'

import ReCAPTCHA from 'react-google-recaptcha'

const Captcha = ({input: { onChange }}) => (
  <div>
    <ReCAPTCHA
      sitekey='6LfkVRcTAAAAAMs2pzknGSd_feaL1hyDNiEzsfsm'
      onChange={onChange}
    />
  </div>
)

export default Captcha


// WEBPACK FOOTER //
// ./src/components/Captcha.js